import React from "react";
import { Box, Typography } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { AccountHeaderTitle } from "../../components/AccountHeader";
import { useFallbackUrl } from "../../components/AppHistory";
import { Crumb } from "../../components/Breadcrumb";
import { PageComponent } from "../routes";
import { AgreementHistoryView } from "../../features/Agreements/AgreementHistoryView";
import { SuccessNotification } from "../../features/Search/components/SuccessNotification";

export const AgreementHistoryPage: PageComponent<{}> = ({ fallbackUrl }) => {
  useFallbackUrl(fallbackUrl);
  const { accountNumber } = useParams();

  return (
    <>
      <Helmet>
        <title>{`${accountNumber} - Account Agreement History`}</title>
      </Helmet>

      <AccountHeaderTitle>
        <Typography variant="h4" color="textPrimary">
          Agreement history
        </Typography>
      </AccountHeaderTitle>

      {/* Breadcrumb */}
      <Crumb label="Agreement History" />

      <Box px={3} py={3} data-testid="AgreementHistoryPage">
        <SuccessNotification />
        <AgreementHistoryView />
      </Box>
    </>
  );
};
